var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateNewConsortium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 54 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1135DAE2-6171-43FF-93D0-4F2A99C05B54") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05_Welcome-to-DeGrid\\u2122",
    transform: "translate(-555.000000, -449.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "block_1",
    transform: "translate(320.000000, 404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(76.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "block_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/create-new-consortium",
    transform: "translate(160.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#0076FC",
    fill: "#CCE4FE",
    cx: 10.5,
    cy: 43.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2463379,39 L10.2463379,47.4926758 M14.4926758,43.2463379 L6,43.2463379",
    id: "Combined-Shape",
    stroke: "#0076FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L47,0 C49.209139,-4.05812251e-16 51,1.790861 51,4 L51,9 L51,9 L4,9 L4,4 C4,1.790861 5.790861,4.05812251e-16 8,0 Z",
    id: "Rectangle",
    fill: "#CCE4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,29.1666667 L4,4.66666667 C4.00768787,2.09252898 6.09252898,0.00768786926 8.66666667,0 L47,0 C49.5741377,0.00768786926 51.6589788,2.09252898 51.6666667,4.66666667 L51.6666667,32.6666667 C51.6589788,35.2408044 49.5741377,37.3256455 47,37.3333333 L25.6666667,37.3333333",
    id: "Path",
    stroke: "#0076FC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.66666667,
    y1: 9.5,
    x2: 51.3333333,
    y2: 9.5,
    id: "Path",
    stroke: "#0076FC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66666667,4.25 C9.34450056,4.25 9.08333333,4.51116723 9.08333333,4.83333333 C9.08333333,5.15549944 9.34450056,5.41666667 9.66666667,5.41666667 C9.98883277,5.41666667 10.25,5.15549944 10.25,4.83333333 C10.25,4.51116723 9.98883277,4.25 9.66666667,4.25",
    id: "Path",
    stroke: "#0076FC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3333333,4.25 C14.0111672,4.25 13.75,4.51116723 13.75,4.83333333 C13.75,5.15549944 14.0111672,5.41666667 14.3333333,5.41666667 C14.6554994,5.41666667 14.9166667,5.15549944 14.9166667,4.83333333 C14.9166667,4.51116723 14.6554994,4.25 14.3333333,4.25",
    id: "Path",
    stroke: "#0076FC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,4.25 C18.6778339,4.25 18.4166667,4.51116723 18.4166667,4.83333333 C18.4166667,5.15549944 18.6778339,5.41666667 19,5.41666667 C19.3221661,5.41666667 19.5833333,5.15549944 19.5833333,4.83333333 C19.5833333,4.51116723 19.3221661,4.25 19,4.25",
    id: "Path",
    stroke: "#0076FC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4459766,15.2255344 L30.0204282,17.1114698 C30.2158113,17.7614192 30.8818701,18.1483733 31.5432669,17.9961795 L33.4562992,17.5531473 C34.2000392,17.3842689 34.9669361,17.720321 35.3469016,18.3816041 C35.726867,19.0428872 35.6309972,19.874675 35.1105573,20.4321795 L33.7814605,21.8750827 C33.319775,22.3745403 33.319775,23.1450446 33.7814605,23.6445021 L35.1200411,25.0860505 C35.6396238,25.643954 35.7350333,26.4753137 35.355348,27.1364201 C34.9756628,27.7975265 34.2095043,28.1340722 33.4657831,27.9664376 L31.5527508,27.5234053 C30.891354,27.3712116 30.2252952,27.7581657 30.0299121,28.408115 L29.4459766,30.298115 C29.2264348,31.0282677 28.554163,31.5281332 27.7917186,31.5281332 C27.0292741,31.5281332 26.3570023,31.0282677 26.1374605,30.298115 L25.5630089,28.4121795 C25.3676018,27.7615913 24.7006611,27.3744693 24.0388153,27.5274698 L22.1271379,27.9705021 C21.3834167,28.1381367 20.6172582,27.801591 20.237573,27.1404846 C19.8578877,26.4793782 19.9532971,25.6480185 20.4728798,25.090115 L21.8114605,23.6485666 C22.2718432,23.1485999 22.2718432,22.3791139 21.8114605,21.8791473 L20.4728798,20.436244 C19.9476978,19.878951 19.8494476,19.0434732 20.2310173,18.3795482 C20.6125869,17.7156233 21.3839361,17.3799199 22.1298476,17.5531473 L24.041525,17.9961795 C24.7033707,18.14918 25.3703114,17.762058 25.5657186,17.1114698 L26.1401702,15.2255344 C26.3611878,14.497637 27.032361,14 27.7930734,14 C28.5537858,14 29.224959,14.497637 29.4459766,15.2255344 Z",
    id: "Path",
    stroke: "#0076FC",
    fillOpacity: 0.2,
    fill: "#0076FC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#0076FC",
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 27.7944282,
    cy: 22.7597924,
    r: 1.94690323
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateNewConsortium);
export default __webpack_public_path__ + "static/media/create-new-consortium.5cc0f710f75d59b14852e02694919ed4.svg";
export { ForwardRef as ReactComponent };